import React from 'react';
import { Grid, List } from 'semantic-ui-react';
import { format } from 'date-fns';

import ListItem from 'components/ListItem';
import EntityNameValue from 'components/EntityNameValue';
import FieldValues from 'components/FieldValues';
import WizardEventSummarySection from 'components/WizardEventSummarySection';
import { SprayEventWizardStep } from 'services/sprayEventWizard/types';

interface Props {
    readOnly: boolean;
    eventWizardStep: SprayEventWizardStep;
    children?: React.ReactElement;
}

export default function EventSummarySchedule({
    readOnly,
    eventWizardStep,
    children
}: Props): React.ReactElement {
    return (
        <WizardEventSummarySection
            title="Schedule"
            sprayEventWizardStep={eventWizardStep}
            readOnly={readOnly}
        >
            <List>
                <Grid>
                    <FieldValues fieldNames={['startDate', 'entityId']}>
                        {({
                            startDate,
                            entityId
                        }): React.ReactElement => (
                            <React.Fragment>
                                <Grid.Row>
                                    <Grid.Column mobile={8} computer={4} tablet={4}>
                                        <ListItem
                                            description="Date"
                                            value={format(
                                                new Date(startDate),
                                                'dd/MM/yyyy'
                                            )}


                                        />
                                    </Grid.Column>
                                    <Grid.Column mobile={8} computer={4} tablet={4}>
                                        <ListItem
                                            description="Orchard"
                                            value={
                                                <EntityNameValue
                                                    entityId={entityId}
                                                />
                                            }


                                        />
                                    </Grid.Column>
                                </Grid.Row>
                                {children}
                            </React.Fragment>
                        )}
                    </FieldValues>
                </Grid>
            </List>
        </WizardEventSummarySection>
    );
}
